import { useState, type MouseEvent } from "react";
import { IconButton, Menu, MenuItem, Tooltip, ListItemText, Radio } from "@mui/material";
import TranslateIcon from "@mui/icons-material/TranslateOutlined";
import { LOCALES, useI18n } from "../i18n";

/**
 * Language picker (Dari / Pashto / English). Lives in the top bar and on the
 * pre-auth screens. The choice is remembered in localStorage by the provider.
 */
export function LanguageSwitcher({ edge }: { edge?: "start" | "end" }) {
  const { locale, setLocale, t } = useI18n();
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);

  function open(e: MouseEvent<HTMLElement>) {
    setAnchor(e.currentTarget);
  }
  function choose(code: (typeof LOCALES)[number]["code"]) {
    setLocale(code);
    setAnchor(null);
  }

  return (
    <>
      <Tooltip title={t("common_language")}>
        <IconButton onClick={open} edge={edge} aria-label={t("common_language")} size="small">
          <TranslateIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {LOCALES.map((l) => (
          <MenuItem key={l.code} selected={l.code === locale} onClick={() => choose(l.code)}>
            <Radio size="small" checked={l.code === locale} sx={{ mr: 0.5, p: 0.5 }} />
            <ListItemText primary={l.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
